// extracted by mini-css-extract-plugin
export var label = "_hm-2";
export var slideContainer = "_hm-0";
export var slider = "_hm-1";